import React, { useState, useCallback, useEffect } from 'react';
import mammoth from 'mammoth';
import { jsPDF } from 'jspdf';
import './FileConverter.css';
import { playSound } from '../../utils/sounds';
import sndFileSelect from '../../sound/10_UI_Menu_SFX/013_Confirm_03.wav';
import sndConvert from '../../sound/10_UI_Menu_SFX/070_Equip_10.wav';
import sndSuccess from '../../sound/SoupTonic UI1 SFX Pack 1 - mp3/SFX_UI_Saved.mp3';
import sndError from '../../sound/10_UI_Menu_SFX/033_Denied_03.wav';
import loadingGif from '../../assets/transition.gif';

const FileConverter = ({ setIsTransitioning }) => {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isConverting, setIsConverting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (setIsTransitioning) setIsTransitioning(false);
  }, [setIsTransitioning]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && (file.name.endsWith('.docx'))) {
      setSelectedDoc(file);
      setSelectedImage(null);
      setError('');
      playSound(sndFileSelect);
    } else {
      setSelectedDoc(null);
      setError('Harap pilih file dengan format .docx');
      playSound(sndError);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
        setSelectedImage(file);
        setSelectedDoc(null);
        setError('');
        playSound(sndFileSelect);
    } else {
        setSelectedImage(null);
        setError('Harap pilih file gambar (jpg, png, dll).');
        playSound(sndError);
    }
  }

  const handleConvert = useCallback(async () => {
    if (!selectedDoc) {
      setError('Pilih file dulu, ya!');
      playSound(sndError);
      return;
    }

    setError('');
    setIsConverting(true);
    playSound(sndConvert);

    try {
      const arrayBuffer = await selectedDoc.arrayBuffer();
      const { value: html } = await mammoth.convertToHtml({ arrayBuffer });

      const doc = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
      });
      
      const margin = { top: 40, right: 40, bottom: 40, left: 40 };
      const contentWidth = doc.internal.pageSize.getWidth() - margin.left - margin.right;

      await doc.html(html, {
        callback: function (doc) {
          const originalFileName = selectedDoc.name.substring(0, selectedDoc.name.lastIndexOf('.'));
          doc.save(`${originalFileName}.pdf`);
          playSound(sndSuccess);
        },
        x: margin.left,
        y: margin.top,
        width: contentWidth,
        windowWidth: contentWidth, 
      });

    } catch (err) {
      console.error('Gagal melakukan konversi:', err);
      setError('Terjadi kesalahan saat mencoba mengonversi file. Coba lagi.');
      playSound(sndError);
    } finally {
      setIsConverting(false);
    }
  }, [selectedDoc]);

  const handleImageToPdfConvert = useCallback(async () => {
    if(!selectedImage) return;
    setError('');
    setIsConverting(true);
    playSound(sndConvert);

    try {
        const reader = new FileReader();
        reader.readAsDataURL(selectedImage);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const doc = new jsPDF('p', 'px', [img.width, img.height]);
                doc.addImage(img, 'PNG', 0, 0, img.width, img.height);
                const originalFileName = selectedImage.name.substring(0, selectedImage.name.lastIndexOf('.'));
                doc.save(`${originalFileName}.pdf`);
                playSound(sndSuccess);
                setIsConverting(false);
            }
        }
    } catch (err) {
        console.error('Gagal melakukan konversi:', err);
        setError('Terjadi kesalahan saat mengonversi gambar.');
        playSound(sndError);
        setIsConverting(false);
    }
  }, [selectedImage]);

  return (
    <div className="file-converter-container">
      <div className="file-converter-card">
        <h1 className="converter-title">Konverter File Ajaib</h1>
        <p className="converter-subtitle">Ubah format gambar atau ubah .docx ke PDF!</p>
        
        {error && <p className="converter-error-message">{error}</p>}

        {isConverting ? (
             <div className="converter-loading">
                <img src={loadingGif} alt="Loading..." />
                <p>Sedang mengubah file...</p>
            </div>
        ) : (
        <div className="converter-main-content">
            <div className="converter-section">
                <h2 className="section-title">Konversi Gambar ke PDF</h2>
                <label className="dropzone">
                    🖼️
                    <span>{selectedImage ? selectedImage.name : 'Pilih File Gambar'}</span>
                    <input type="file" accept="image/*" onChange={handleImageChange} style={{display: 'none'}} />
                </label>
                <button onClick={handleImageToPdfConvert} disabled={!selectedImage} className="convert-button">
                    Ubah ke PDF
                </button>
            </div>
            
            <div className="divider-or">ATAU</div>

            <div className="converter-section">
                <h2 className="section-title">Konversi Dokumen ke PDF</h2>
                 <label className="dropzone">
                    📄
                    <span>{selectedDoc ? selectedDoc.name : 'Pilih File .docx'}</span>
                    <input type="file" accept=".docx" onChange={handleFileChange} style={{display: 'none'}} />
                </label>
                <button onClick={handleConvert} disabled={!selectedDoc} className="convert-button">
                    Ubah ke PDF
                </button>
            </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default FileConverter; 